import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';
import { TDocumentoSolicitudExViewModel } from '../documentos/documentosEx.types';

export class AlegacionExViewModel {
    public IdSolicitudEx: number;
    public FechaRechazo: Date;
    public ObservacionesAlegacion: string;
    public FechaAlegacion: Date | null = null;
    public Decision: boolean | null;
    public ObservacionesDecision: string;
    public FechaDecision: Date | null = null;
    public IdEstadoSolicitudEx: number;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPrevia: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
    public TDocumentoSolicitudExCollection: TDocumentoSolicitudExViewModel[];
}

//export class TwDocumentoAlegacionExViewModel {

//    public Id: number;
//    public IdSolicitudEx: number;
//    public Fecha: Date | null = null;
//    public NombreArchivo: string;
//    public Size: number | null = null;
//    public CodigoStorage: string;
//    public OldCodigoStorageCollection: string[] = [];
//    public IdEstadoSolicitudEx: number;
//    public IdEstadoSolicitudExDescripcion: string;
//    public IdEstadoCertificadoFitoEx: number;
//    public IdEstadoCertificadoFitoExDescripcion: string;
//    public IdTipoSolicitudExDescripcion: string;
//    public CodigoTipoSolicitud: string;
//    public CodigoSolicitud: string;
//    public EsPrevia: boolean;
//    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
//}
